<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { notify } from "@kyvg/vue3-notification";
import LineUpPlayer from './LineUpPlayer.vue';

const { tournamentType } = defineProps({
    tournamentType: String,
})
const lineUp = ref(null)
const canEdit = ref(false)
const isEditing = ref(false)
const roster = ref([])
const positions = ref([])
const lineUpToSave = ref([])
const firstLine = computed(() => {
    return tournamentType === '3'
        ? [
            { name: 'LW', icon: 'W', class: 'align-self-start' },
            { name : 'LD', icon: 'D', class: 'align-self-end' },
            { name : 'C', icon: 'C', class: 'align-self-start' },
        ]
        : [
            { name: 'LW', icon: 'LW', class: 'align-self-start' },
            { name : 'C', icon: 'C', class: 'align-self-end' },
            { name : 'RW', icon: 'RW', class: 'align-self-start' },
        ]
})
const secondLine = computed(() => {
    return tournamentType === '3'
        ? [
            { name : 'G', icon: 'G', class: '' },
        ]
        : [
            { name: 'LD', icon: 'LD', class: 'align-self-start' },
            { name : 'G', icon: 'G', class: 'align-self-end' },
            { name : 'RD', icon: 'RD', class: 'align-self-start' },
        ]
})
const positionMap = {
    'LW': 'LW',
    'LD': 'LD',
    'C': 'C',
    'RW': 'RW',
    'RD': 'RD',
    'G': 'G',
    'W': 'LW',
    'D': 'LD',
}

onMounted(() => {
    readLineUp()
})

watch(() => tournamentType, (newValue) => {
    lineUp.value = null
    readLineUp(newValue)
})

function readLineUp() {
    fetch(LINE_UP_URL + '?' + new URLSearchParams({tournament_type: tournamentType}).toString())
        .then(response => response.json())
        .then(data => {
            lineUp.value = data.data.line_up
            canEdit.value = data.data.can_edit
            roster.value = data.data.roster
            positions.value = data.data.positions
        })
}

function saveLineUp() {
    fetch(LINE_UP_URL, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        body: JSON.stringify({line_up: lineUpToSave.value, tournament_type: tournamentType})
    })
        .then(response => {
            if (response.ok) {
                return
            }

            onClickEditButton()
            notify({
                title: 'Ошибка сохранения',
                text: 'Некорректно заполнен состав',
                type: 'error',
            })
        })
}

function onClickEditButton() {
    isEditing.value = true
    lineUpToSave.value = []
}

function onSaveLineUp(playerId, icon) {
    isEditing.value = false
    lineUpToSave.value.push({
        player_id: playerId,
        position_id: positions.value.find(p => p.short_title === positionMap[icon]).id
    })
    if (!lineUp.value) {
        lineUp.value = {}
    }
    lineUp.value[positionMap[icon]] = roster.value.find(p => p.id === playerId)

    if (lineUpToSave.value.length === firstLine.value.length + secondLine.value.length) {
        saveLineUp()
    }
}
</script>

<template>
    <button v-if="canEdit && !isEditing" class="btn btn-link position-absolute end-0 top-0" @click="onClickEditButton">
        <i class="fa fa-cog"></i>
    </button>
    <h5 class="text-center">
        Стартовый состав
    </h5>
    <div class="text-center">
        <img v-if="tournamentType === '3'" src="/images/3x3.svg" alt="3x3" height="50">
        <img v-else src="/images/6x6.svg" alt="6x6" height="50">
    </div>
    <div class="container text-center small fw-bold">
        <div class="row" style="height: 100px;">
            <template v-for="line in firstLine" :key="line.name">
                <div :class="['col', 'p-0', line.class]">
                    <line-up-player :player="lineUp ? lineUp[line.name] : null"
                                    :icon="line.icon"
                                    :is-editing="isEditing"
                                    :roster="roster"
                                    @save="onSaveLineUp"
                    />
                </div>
            </template>
        </div>
        <div class="row" style="height: 100px;">
            <template v-for="line in secondLine" :key="line.name">
                <div :class="['col', 'p-0', line.class]">
                    <line-up-player :player="lineUp ? lineUp[line.name] : null"
                                    :icon="line.icon"
                                    :is-editing="isEditing"
                                    :roster="roster"
                                    @save="onSaveLineUp"
                    />
                </div>
            </template>
        </div>
    </div>
    <div v-if="isEditing" class="text-center mt-2">
        <button class="btn btn-primary w-75" @click="isEditing = false">Сохранить</button>
    </div>
</template>
